module.exports = __webpack_public_path__ + "web/img/verify8.02077e52.jpg";